import { SelectDropdownModel } from "@app/models/components/select-dropdown.model";

export class SearchWordConstant {

  static listSearchWordKorea: SelectDropdownModel[] = [
    { label: "제목", value: "T" },
    { label: "내용", value: "C" },
    { label: "제목 + 내용", value: "A" },
  ];

  static listSearchWordEng: SelectDropdownModel[] = [
    { label: "Title", value: "T" },
    { label: "Content", value: "C" },
    { label: "Title + Content", value: "A" },
  ];
}